import { gql, useQuery } from '@apollo/client';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useParams } from 'react-router';
import { useStats } from '../../hooks/useStats';
import OpenApplication from './OpenApplication';

const NavbarTop = () => {
  const { t } = useTranslation();
  return (
    <div className="navbar-top items-center m-0 px-2">
      <div className="vertical-center mx-auto">
        <NavLink className={({ isActive }) => (isActive ? 'active' : '')} end to="/">
          <img
            src="/logo/LogoNaked@0.5x.png"
            className="navbar-logo py-4 mr-2 ml-1"
            alt={t('openApplicationContainer.logoAlt')}
          />
        </NavLink>
        <div className="flex-grow lg:flex mx-0 px-0 justify-end"></div>
      </div>
    </div>
  );
};

const ContentNotAllwed = ({ text }: { text: string }) => {
  return (
    <div className="vertical-center text-center h-full justify-center" style={{ minHeight: '200px' }}>
      {text}
    </div>
  );
};

const OPEN_APPLICATION_QUERY = gql`
  query pub_CheckExpiration($applicationId: String!) {
    checkOpenSummaryExpirationDate(applicationId: $applicationId) {
      expiry
      disabled
    }
  }
`;

const Loading = () => {
  const { t } = useTranslation();
  return <ContentNotAllwed text={t('openApplicationContainer.loading')} />;
};

const OpenApplicationContainer = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const [now] = useState(() => Date.now());

  const { data } = useQuery(OPEN_APPLICATION_QUERY, {
    variables: { applicationId: id },
    skip: !id,
  });

  useStats({ action: 'view_open_summary', id }, []);

  const expiry = data?.checkOpenSummaryExpirationDate?.expiry;
  const isExpired = expiry != null ? now >= expiry : null;

  return (
    <>
      <NavbarTop />
      {id && isExpired === false ? (
        <OpenApplication applicationId={id} whileLoading={<Loading />} />
      ) : isExpired === true ? (
        <ContentNotAllwed text={t('openApplicationContainer.linkExpired')} />
      ) : (
        <Loading />
      )}
    </>
  );
};

export default OpenApplicationContainer;
